export const TRACKER_SHOW_NPS_BANNER = '[NPS Banner] show banner';
export const TRACKER_CANCEL_NPS_FEEDBACK = '[NPS Banner] cancel feedback';
export const TRACKER_NPS_BANNER_RATE = '[NPS Banner] rate';
